import { a as a$3 } from './chunk-742R2ACG.mjs';
import { a } from './chunk-K7PMXFLS.mjs';
import { a as a$1 } from './chunk-Q5VQGRFH.mjs';
import { a as a$2 } from './chunk-XCSSTYD2.mjs';
import e from 'react';
import { DynamicContainer, Loading, DynamicContainerContent } from '@crossbell/ui';
import { create } from 'zustand';

var m="64f64c8c7f6ff564e2a4290e1dc4fb9b83b89cb6a48697c03346a44a3efe41ed",h=`._modal_5dy7w_1 {
	margin-top: auto;
	width: 100%;
	color: rgb(var(--csb-ck-color-text));
	background: rgb(var(--csb-ck-color-bg));
	border-top-left-radius: 28px;
	border-top-right-radius: 28px;
}

._modal_5dy7w_1 * {
	box-sizing: border-box;
}

@media (min-width: 768px) {
	._modal_5dy7w_1 {
		margin-bottom: auto;
		width: auto;
		border-bottom-left-radius: 28px;
		border-bottom-right-radius: 28px;
	}
}

._inner_5dy7w_23 {
	padding: 0;
}
`;(function(){if(!(typeof document>"u")&&!document.getElementById(m)){var o=document.createElement("style");o.id=m,o.textContent=h,document.head.appendChild(o);}})();var s={modal:"_modal_5dy7w_1",inner:"_inner_5dy7w_23"};var p="449ccb0ffd4e1a4dc33eb4df5ec153db33e9d2e369631dbd4666154a09eb188d",C=`._placeholder_1itgg_1 {
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 2em;
	color: rgba(var(--csb-ck-color-text), 0.5);
	height: 30vh;
}

@media (min-width: 768px) {
	._placeholder_1itgg_1 {
		width: 360px;
		height: 300px;
	}
}
`;(function(){if(!(typeof document>"u")&&!document.getElementById(p)){var o=document.createElement("style");o.id=p,o.textContent=C,document.head.appendChild(o);}})();var f={placeholder:"_placeholder_1itgg_1"};function n(o,a,t){let u=t?.Modal??a$3;return function(){let{isActive:y,hide:g}=o(),r=e.createElement(e.Suspense,{fallback:e.createElement(M,{noDynamicContainer:t?.noDynamicContainer,className:t?.loadingClassName})},e.createElement(a,null));return e.createElement(u,{isActive:y,onClose:g},t?.noDynamicContainer?r:e.createElement(DynamicContainer,null,r))}}function M({noDynamicContainer:o,className:a}){let t=e.createElement("div",{className:a??s.modal},e.createElement("div",{className:f.placeholder},e.createElement(Loading,null)));return o?t:e.createElement(DynamicContainerContent,{id:"lazy-modal/placeholder"},t)}var U=n(a,e.lazy(()=>import('./lazy-DH3PVOIQ.mjs')));var G=n(a$1,e.lazy(()=>import('./lazy-OWERX7W5.mjs')));var X=create((o,a)=>({...a$2(o,a),kind:"claim-csb",show(t){o({kind:t,isActive:!0});}}));

export { n as a, U as b, G as c, X as d };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-S2PNULF6.mjs.map